import React from "react";
import PropTypes from "prop-types";
import { HighlightProvider as SharedHighlightProvider } from "@learningblocks/shared-components";
import { useHighlight } from "@learningblocks/shared/glossary";
import cName from "./style.module.scss";
import { PlainText } from "@learningblocks/storybook-components";

/**
 * Question
 *    -Component accepts the HTML question text and render it to HTML
 */

export function Question(props) {
  const { onPlainTextClick } =
    React.useContext(SharedHighlightProvider.Context) || useHighlight();

  const onClickHighlight = (contentId, event) => {
    onPlainTextClick(contentId, event);
  };

  return (
    <PlainText
      // key={component.id}
      text={props.text}
      className={`${cName.question} ${props.className}`}
      onClickHighlight={onClickHighlight}
    />
  );
}

Question.propTypes = {
  /**
   * Text to be  displayed as question
   * Expects a string p tag
   */
  text: PropTypes.string.isRequired,
  /**
   * ClassName to set on the tag
   */
  className: PropTypes.string,
};

Question.defaultProps = {
  text: "",
  className: "",
};
